import { TableSortLabel, styled } from '@mui/material';

export const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
  '&:focus': {
    outline: '1px solid black',
  },
}));
